/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: UserAppLinkageTable
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 28Feb2022 craig File created.
 \******************************************************************************/
import React from "react";
import {ITeamUserLinkage} from "../models/application/IApplication";
import {Accordion, Button, Col, Container, Row} from "react-bootstrap";
import AccordionItem from "react-bootstrap/AccordionItem";
import AccordionHeader from "react-bootstrap/AccordionHeader";
import AccordionBody from "react-bootstrap/AccordionBody";

export const TeamUsersTable = (linkages?: ITeamUserLinkage[], showMembers?: boolean, showDelete?: boolean) => {

    if (linkages === undefined || linkages.length === 0) {
        return (
            <Container>
                <Row>
                    <Col>No users found</Col>
                </Row>
            </Container>
        )
    }
    let show: string = "0";
    if (showMembers === undefined || showMembers === false) {
        show = "1";
    }
    if (showDelete === undefined) {
        showDelete = false;
    }

    return (
        <Accordion defaultActiveKey="0" flush>
            <AccordionItem eventKey={show}>
                <AccordionHeader>Team Members</AccordionHeader>
                <AccordionBody>
                    <Container>
                        <Row className="header-container">
                            <Col>Name</Col>
                            <Col>Email</Col>
                            <Col>Role</Col>
                            <Col></Col>
                            {showDelete &&
                            <Col></Col>
                            }
                        </Row>
                        {linkages?.map((linkage: ITeamUserLinkage) => (
                            <Row>
                                <Col>{linkage.GSUser?.FirstName + " " + linkage.GSUser?.LastName}</Col>
                                <Col>{linkage.GSUser?.EmailAddress}</Col>
                                <Col>{linkage.GSUser?.Role.Role}</Col>
                                <Col><Button href={"/admin/teammember/" + linkage.TeamID + "/" + linkage.GSUser?.UserID}
                                             variant={"link"}>{'Edit'}</Button></Col>
                                {showDelete &&
                                <Col><Button href={"/admin/user/" + linkage.GSUser?.UserID}
                                             variant={"link"}>{'Delete'}</Button></Col>
                                }
                            </Row>
                        ))}
                    </Container>
                </AccordionBody>
            </AccordionItem>
        </Accordion>
    )
}

